export default "__VITE_ASSET__CiW5YK73__"